// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2PrW0","selects":"Documents_selects__2dUBh"};